<template>
    <div style="width: 1000px; height: 1000px">
        <CardEditorIframe
            :id="cardId"
            :tag="'saveCard'"
            @save-success="saveCallback"
            v-if="null != cardId"
        />
    </div>
</template>

<script setup>

import CardEditorIframe from "@/components/shopopee/card/cardEditorIframe.vue";
import {inject, onBeforeMount, ref, toRef, getCurrentInstance} from "vue";
import myUtil from "@/util/util";
import cardApi from "@/request/api";

const props = defineProps(["acccompanycode"])

const acccompanycode = ref(null)
const host = ref(null)
const cardId = ref(null)

function getCardId(){
    const request = cardApi.queryMemberWorkByAcccode
    const params = request.getParams()

    params.acccompanycode = acccompanycode.value
    params.currentcapital = host.value

    request.send(params, (res) => {
        if (res.code == 200){
            if (null != res.detail){
                cardId.value = res.detail.id
            }
        }else{
            window.parent.postMessage({ type: 'saveError',  data: { msg: "名片不存在" } }, '*')
        }
    })

}

function saveCallback(){
    try{
        window.parent.postMessage({ type: 'saveComplete',  data: {} }, '*')
    }catch (e){

    }

}



onBeforeMount(() => {
    acccompanycode.value = myUtil.getUrlValue("acc")
    host.value = myUtil.getUrlValue("host")

    if (null != acccompanycode.value && null != host.value){
        getCardId()
    }else{
        window.parent.postMessage({ type: 'saveError',  data: { msg: "參數錯誤" } }, '*')
    }

})

</script>

<style scoped>

</style>